export const VS_URL = {
  PC_DOMAIN: process.env.NEXT_PUBLIC_PC_DOMAIN as string,
  MOBILE_DOMAIN: process.env.NEXT_PUBLIC_MOBILE_DOMAIN as string,
  VISA_APPLICATION_FORM: '/file/220117-visa-application-form.pdf',
  VISA_NAVIGATOR: 'https://www.visa.go.kr/openPage.do?MENU_ID=10101',
  VISA_REQUIRED_DOCUMENTS_INFO: 'https://qingdao.mofa.go.kr/cn-qingdao-zh/brd/m_1374/list.do',
} as const;
